type OnboardingStep = 'Company' | 'Info' | 'Contact' | 'Complete';

const ONBOARDING_STEPS: OnboardingStep[] = ['Company', 'Info', 'Contact', 'Complete'] as const;

export type UseOnboardingReturn = {
    isOnboardingInProgress: ComputedRef<boolean>;
    canSkipOnboarding: ComputedRef<boolean>;
    currentStep: ComputedRef<OnboardingStep | undefined>;
    goNext: VoidFunction;
};

export const useOnboarding = (): UseOnboardingReturn => {
    const { data: session } = useAuthUtils();

    const isOnboardingInProgress = computed(() => session.value?.user?.onboardingSessionFinishedAt === null);

    const canSkipOnboarding = computed(() => isOnboardingInProgress.value && !!session.value?.user?.company && !!session.value?.user?.phone);

    const getInitialStep = (): number => {
        if (canSkipOnboarding.value) {
            return ONBOARDING_STEPS.indexOf('Complete');
        }

        if (session.value?.user?.company) {
            return ONBOARDING_STEPS.indexOf('Contact');
        }

        return ONBOARDING_STEPS.indexOf('Company');
    };

    const stepIndex = ref<number>(getInitialStep());

    const currentStep = computed(() => ONBOARDING_STEPS.at(stepIndex.value));

    const goNext = (): void => {
        if (stepIndex.value === ONBOARDING_STEPS.length) return;

        stepIndex.value = stepIndex.value + 1;
    };

    return {
        isOnboardingInProgress,
        canSkipOnboarding,
        currentStep,
        goNext,
    };
};
